export interface HeaderTabType {
  path: string;
  text: string;
  badge?: number;
}

export enum HeaderActionTypes {
  ICON_BUTTON = 'ICON_BUTTON',
  SELECT = 'SELECT',
}
